import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const Content = styled.div`
	height: 100%;
	overflow: hidden;
`;

export const ContentWrapper = styled.div`
	height: 100%;
	display: flex;
`;

export const ColumnWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const MiddleContent = styled(ColumnWrapper)`
	background-color: ${colors.grey1};
	min-width: 400px;
`;

export const SidebarPanel = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	background-color: ${colors.white};
	transition: width 0.2s linear;
	width: 100%;
	position: relative;
	overflow: hidden;
`;
